import React from 'react';
import { Trail } from '../../../../models/Trail';
import {
	FullBackgroundImg,
	IntroTourLine,
	VTIntroInner,
	VTMeta,
	VTShortDescription,
} from '../virtualTourStyles';
import { Wash } from '../../../Global/styles';
import { checkImage } from '../../../componentUtils';

type IntroSlideProps = {
	trail: Trail;
};

const IntroSlide: React.FC<IntroSlideProps> = ({ trail }) => {
	return (
		<>
			<FullBackgroundImg src={checkImage(trail.image)} />
			<Wash />
			<VTIntroInner>
				<h2>{trail.title}</h2>
				<VTMeta>Virtual tour</VTMeta>
				<VTShortDescription>
					{trail.short_description}
				</VTShortDescription>
			</VTIntroInner>
			<IntroTourLine />
			{/* <ForwardArrow /> */}
		</>
	);
};

export default IntroSlide;
